import { createSlice } from "@reduxjs/toolkit";
import { reviewBenefitsAPI } from "../../../services/guestUsers/guestUserAllAPIService";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const reviewBenefitsSlice = createSlice({
  name: "reviewBenefitsSlice",
  initialState,
  reducers: {
    reviewBenefitsInfo(state) {
      state.isLoading = true;
      state.message = "";
    },
    reviewBenefitsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    reviewBenefitsFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    reviewBenefitsReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const reviewBenefitsHandler = (payload = {}) => async (dispatch) => {
  try {
    dispatch(reviewBenefitsSliceAction.reviewBenefitsInfo());
    const response = await reviewBenefitsAPI(payload);
    dispatch(reviewBenefitsSliceAction.reviewBenefitsSuccess(response));
    return response;
  } catch (e) {
    dispatch(reviewBenefitsSliceAction.reviewBenefitsFailure(e));
    return null;
  }
};

export default reviewBenefitsSlice.reducer;
export const reviewBenefitsSliceAction = reviewBenefitsSlice.actions;
